import React, { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "store";
import Layout from "components/layout";

const Home = lazy(() => import("./pages/Home"));
const ServerError = lazy(() => import("./components/layout/ServerError"));
const Page404 = lazy(() => import("./components/layout/404"));
const FrameDetails = lazy(() => import("pages/FrameDetails"));
const LensesFlow = lazy(() => import("pages/lensesFlow"));
const Login = lazy(() => import("pages/Auth/Login"));
const SignUp = lazy(() => import("pages/Auth/Signup"));
const VerifyCode = lazy(() => import("pages/Auth/VerifyCode"));
const Registration = lazy(() => import("pages/Auth/Registration"));
const Cart = lazy(() => import("pages/Cart"));
const ContactDetails = lazy(() => import("pages/ContactDetails"));
const Orders = lazy(() => import("pages/Orders"));
const CompleteOrder = lazy(() => import("pages/completeOrdering"));
const ProductsLayout = lazy(() => import("pages/products"));
const Frames = lazy(() => import("pages/products/Frames"));
const Contacts = lazy(() => import("pages/products/Contacts"));
const CollectionsIndex = lazy(() => import("pages/collections"));
const CollectionPage = lazy(() => import("pages/collections/CollectionPage"));

const router = () => {
  const userData: UserData = useAppSelector((state) => state.auth.userData);

  return [
    {
      path: "/",
      element: <Layout />,
      errorElement: <ServerError />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/frame-details/:id",
          element: <FrameDetails />,
        },
        {
          path: "/contact-details/:id",
          element: <ContactDetails />,
        },
        {
          path: "/login",
          element: !userData ? <Login /> : <Navigate to="/" />,
        },
        {
          path: "/sign-in",
          element: !userData ? <Login /> : <Navigate to="/" />,
        },
        {
          path: "/signin",
          element: !userData ? <Login /> : <Navigate to="/" />,
        },
        {
          path: "/sign-up",
          element: !userData ? <SignUp /> : <Navigate to="/" />,
        },
        {
          path: "/signup",
          element: !userData ? <SignUp /> : <Navigate to="/" />,
        },
        {
          path: "/verify-code/:phone_number",
          element: !userData ? <VerifyCode /> : <Navigate to="/" />,
        },
        {
          path: "/registration/:phone_number",
          element: !userData ? <Registration /> : <Navigate to="/" />,
        },
        {
          path: "/collections",
          element: <CollectionsIndex />,
        },
        {
          path: "/collections/:slug",
          element: <CollectionPage />,
        },
        {
          path: "",
          element: <Navigate to="/" />,
        },
        {
          path: "*",
          element: <Page404 />,
        },
      ],
    },
    {
      path: "/select-lenses/*",
      element: <LensesFlow />,
      errorElement: <ServerError />,
    },
    {
      path: "/cart",
      element: <Cart />,
      errorElement: <ServerError />,
    },
    {
      path: "/orders",
      element: userData ? <Orders /> : <Navigate to="/" />,
      errorElement: <ServerError />,
    },
    {
      path: "/complete-order/*",
      element: <CompleteOrder />,
      errorElement: <ServerError />,
    },
    {
      path: "/products",
      element: <ProductsLayout />,
      errorElement: <ServerError />,
      children: [
        { index: true, element: <Navigate to="/products/all" replace /> },
        { path: "all", element: <Frames /> },
        { path: "frames", element: <Frames categoryId={1} /> },
        { path: "sunglasses", element: <Frames categoryId={2} /> },
        { path: "accessories", element: <Frames categoryId={4} /> },
        { path: "contacts", element: <Contacts /> },
        { path: "*", element: <Navigate to="/products/all" replace /> },
      ],
    },
    {
      path: "",
      element: <Navigate to="/" />,
      errorElement: <ServerError />,
    },
    {
      path: "*",
      element: <Page404 />,
      errorElement: <ServerError />,
    },
  ];
};

export default router;
